import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Opens a popover to the right of its trigger, or flips it to align right if it would run off screen. Measured again
 * when the window resizes while it is open (a tablet turned, a window narrowed), so it never sticks out sideways.
 */
export function usePopoverAlign(open: boolean) {
  const popRef = useRef<HTMLDivElement>(null)
  const [alignRight, setAlignRight] = useState(false)
  useLayoutEffect(() => {
    // Measuring the rendered popover is what a layout effect is for; the extra render happens before paint.
    /* eslint-disable react-hooks/set-state-in-effect */
    if (!open) {
      setAlignRight(false)
      return
    }
    const measure = () => {
      const el = popRef.current
      const trigger = el?.parentElement?.getBoundingClientRect()
      if (!el || !trigger) return
      const width = el.getBoundingClientRect().width
      setAlignRight(trigger.left + width > document.documentElement.clientWidth - 8)
    }
    measure()
    /* eslint-enable react-hooks/set-state-in-effect */
    window.addEventListener('resize', measure)
    return () => {
      window.removeEventListener('resize', measure)
    }
  }, [open])
  return { popRef, alignRight }
}
